var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.956 -0.956) scale(1.0797)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.24339 17.5827L10.586 5.60238C11.0446 4.73599 11.274 4.30279 11.5799 4.16116C11.8464 4.0378 12.1536 4.0378 12.4201 4.16116C12.7261 4.30279 12.9554 4.73599 13.4141 5.60237L19.7566 17.5827C20.1669 18.3577 20.3721 18.7452 20.3306 19.0614C20.2944 19.3373 20.1449 19.5857 19.918 19.7468C19.658 19.9313 19.2195 19.9313 18.3426 19.9313H5.65746C4.78053 19.9313 4.34207 19.9313 4.08207 19.7468C3.85514 19.5857 3.7056 19.3373 3.66941 19.0614C3.62794 18.7452 3.83309 18.3577 4.24339 17.5827Z",
    stroke: "currentColor",
    strokeWidth: 1.389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeTriangle);
export default __webpack_public_path__ + "static/media/shape-triangle.2b71ec637be8e76701c7d715f06c9e0d.svg";
export { ForwardRef as ReactComponent };